import WarningIcon from '@mui/icons-material/Warning'
import InfoIcon from '@mui/icons-material/Info'
import { defaultPalette } from '../../../theme/idsTheme'
import { CalloutStyles } from './_props'

export const calloutStyles: CalloutStyles = {
    INFO: {
        color: defaultPalette.lightGrey.darker,
        background: defaultPalette.lightGrey.ultraLight,
        icon: <InfoIcon />,
    },
    WARNING: {
        color: defaultPalette.orangeWarning.main,
        background: defaultPalette.orangeWarning.half,
        icon: <WarningIcon />,
    },
}
